import * as yup from 'yup';

const formSchema = yup.object().shape({
  email: yup.string().required().label('Field can’t be empty'),
  password: yup.string().required().label('Field can’t be empty'),
});

export default formSchema;
